import { render, staticRenderFns } from "./EventStats.vue?vue&type=template&id=530f3b9d"
import script from "./EventStats.vue?vue&type=script&lang=js"
export * from "./EventStats.vue?vue&type=script&lang=js"
import style0 from "./EventStats.vue?vue&type=style&index=0&id=530f3b9d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports